import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  uuid: null,
  crypto_random: null,
  token: null,
  exp: null,
  refresh_token: null,
  code_pkce: null,
  menu:null,
  isAuthenticated: false,
  language: null,
  refresh : 1,
}

const authSlice = createSlice({
  name:"auth",
  initialState:INITIAL_STATE,
  reducers:{
    login(state, data) {
      state.token = data.payload
      state.isAuthenticated = true
    },
    setLanguage(state,data){
      state.language = data.payload
    },
    refreshPage(state,data) {
      state.refresh = state.refresh + data.payload
  },
  }
})

export const authActions = authSlice.actions;
export default authSlice.reducer